var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('header',{staticClass:"shrink-0"},[_c('Menu')],1),_vm._v(" "),_c('main',{staticClass:"flex-1 min-h-0 flex flex-col"},[_c('Nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }